const iconHome = `
  <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
    <g fill="none">
      <path d="M0 0h30v30H0z"/>
      <g class="icon-color" fill-rule="nonzero" transform="translate(2 4)" fill="#038AB7">
        <path
          d="M12.5188131,0 L26,12.420373 L21.1801774,12.420373 L21.1801774,
            21.9684362 L15.4059345,21.9684362 L15.4059345,13.3751793
            L10.5940655,13.3751793 L10.5940655,21.9684362 L4.81982258,
            21.9684362 L4.81982258,12.420373 L0,12.420373 L12.5188131,0 Z"
        >
        </path>
      </g>
    </g>
  </svg>
`

export default iconHome
